// Content mapping for search
const websiteContent = {
  '/': {
    title: 'Home',
    content: 'WTT International - Water Loving Technology. Leading provider of water treatment solutions.',
    keywords: ['home', 'wtt', 'water treatment', 'technology']
  },
  '/about': {
    title: 'About Us',
    content: 'WTT International is a leading water treatment company specializing in innovative solutions.',
    keywords: ['about', 'company', 'history', 'mission']
  },
  '/products/waste-water-treatment': {
    title: 'Waste Water Treatment Systems',
    content: 'Advanced solutions for sustainable water management and environmental compliance. Effluent Treatment Plant, Common Effluent Treatment, Sewage Treatment, Oil Water Separator, Industrial Recycling, Packaged STP, Zero Liquid Discharge (ZLD), DM Plant.',
    keywords: ['waste water', 'treatment', 'effluent', 'sewage', 'recycling', 'zld', 'dm plant']
  },
  '/products/equipment-systems': {
    title: 'Equipment & Systems',
    content: 'High-quality water treatment equipment and systems for industrial and commercial applications.',
    keywords: ['equipment', 'systems', 'industrial', 'commercial']
  },
  '/solutions/ro-treatment': {
    title: 'RO Treatment',
    content: 'Reverse Osmosis treatment solutions for pure and clean water.',
    keywords: ['ro', 'reverse osmosis', 'treatment', 'purification']
  },
  '/solutions/scada': {
    title: 'SCADA System',
    content: 'Advanced SCADA systems for water treatment monitoring and control.',
    keywords: ['scada', 'monitoring', 'control', 'automation']
  },
  '/solutions/iot': {
    title: 'IoT Platform',
    content: 'IoT solutions for smart water management and monitoring.',
    keywords: ['iot', 'smart', 'monitoring', 'platform']
  }
};

function searchWebsite(query) {
  const searchResults = [];
  const searchTerm = query.toLowerCase();

  Object.entries(websiteContent).forEach(([path, pageData]) => {
    const { title, content, keywords } = pageData;
    
    // Check if search term exists in title, content, or keywords
    const titleMatch = title.toLowerCase().includes(searchTerm);
    const contentMatch = content.toLowerCase().includes(searchTerm);
    const keywordMatch = keywords.some(keyword => 
      keyword.toLowerCase().includes(searchTerm)
    );

    if (titleMatch || contentMatch || keywordMatch) {
      // Calculate relevance score
      let score = 0;
      if (titleMatch) score += 3;
      if (contentMatch) score += 2;
      if (keywordMatch) score += 1;

      // Create excerpt with highlighted search term
      let excerpt = content;
      if (content.length > 150) {
        const startIndex = content.toLowerCase().indexOf(searchTerm);
        const start = Math.max(0, startIndex - 60);
        excerpt = '...' + content.slice(start, start + 150) + '...';
      }

      searchResults.push({
        title,
        path,
        excerpt,
        score
      });
    }
  });

  // Sort results by relevance score
  return searchResults.sort((a, b) => b.score - a.score);
}

export { searchWebsite }; 